// eslint-disable-next-line import/no-anonymous-default-export
export default (newAsset = [], action) => {
  switch (action.type) {
    case "GET_NEW_UNAPPROVED_ASSETS":
      return action.payload;
    case "APPROVE_NEW_ASSET":
      return newAsset.filter((lo) => lo.approved === "false");
    case "DELETE_NEW_ASSET":
      return newAsset.filter((lo) => lo._id !== action.payload);
    default:
      return newAsset;
  }
};
